export const bimpConfig = {
    // Protocol for Simulation Service
    // API key for errorstack.com error reporting
    errorStackApiKey: '113bc68104159d944619f8331ab989f8',
    host: process.env.GATSBY_BIMP_QBP_API_HOST,
    protocol: process.env.GATSBY_BIMP_QBP_API_PROTOCOL,
    url: '/rest/v1/Simulation',
    linkPrefix: '/simulator/',
    basicAuth: {
        username: 'limited',
        password: 'limited'
    }
}
